import React, { PureComponent } from "react";
import HelpIconButtonWithTooltipAndTypeformModal from "../../../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import HorizontalBarChart from "../../../ceo/analysis/competitive/charts/horizontal-bar";
import VerticalBarChart from "../../../ceo/analysis/competitive/charts/vertical-bar";
import TypeformContent from "../../../typeform/TypeformContent";

class Kpis2 extends PureComponent {
  getDataValue = (team_id, key) => {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    let val = data[team_id][key];

    if (!val) {
      return 0;
    }

    return val;
  };

  get ROIC() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value: this.getDataValue(team_id, "ROIC") * 100
      });
    });

    return data;
  }

  get RNOA() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value: this.getDataValue(team_id, "RNOA") * 100
      });
    });

    return data;
  }

  get EarningPerShare() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value: this.getDataValue(team_id, "Earnings Per Share")
      });
    });

    return data;
  }

  get SharePrice() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value: this.getDataValue(team_id, "Share Price")
      });
    });

    return data;
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-3 col-xs-12">
          <div className="bg-white p-30">
            <HorizontalBarChart prefix="$" data={this.SharePrice} />
            <div className="text-center" style={{ marginTop: "-20px" }}>
              Share Price
              <HelpIconButtonWithTooltipAndTypeformModal
                iconSize="xs"
                {...TypeformContent.STOCK_PRICE}
              />
            </div>
          </div>
        </div>
        <div className="col-md-3 col-xs-12">
          <div className="bg-white p-30">
            <VerticalBarChart prefix="$" data={this.EarningPerShare} />
            <div className="text-center" style={{ marginTop: "-20px" }}>
              Earnings Per Share
              <HelpIconButtonWithTooltipAndTypeformModal
                iconSize="xs"
                {...TypeformContent.EARNINGS_PER_SHARE}
              />
            </div>
          </div>
        </div>
        <div className="col-md-3 col-xs-12">
          <div className="bg-white p-30">
            <VerticalBarChart suffix="%" data={this.ROIC} />
            <div className="text-center" style={{ marginTop: "-20px" }}>
              Return on Invested Capital
              <HelpIconButtonWithTooltipAndTypeformModal
                iconSize="xs"
                {...TypeformContent.ROIC_KPI}
              />
            </div>
          </div>
        </div>
        <div className="col-md-3 col-xs-12">
          <div className="bg-white p-30">
            <VerticalBarChart suffix="%" data={this.RNOA} />
            <div className="text-center" style={{ marginTop: "-20px" }}>
              Return on Net Operating Assets
              <HelpIconButtonWithTooltipAndTypeformModal
                iconSize="xs"
                {...TypeformContent.RNOA_KPI}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Kpis2;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/kpis-2.js